import { render, staticRenderFns } from "./StudentCourseRecord.vue?vue&type=template&id=512b7692&"
import script from "./StudentCourseRecord.vue?vue&type=script&lang=js&"
export * from "./StudentCourseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports